import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { batchList } from "../../api/Batch";
import { useLocation, useNavigate } from "react-router-dom";
import {
  studentBatchEnroll,
  studentDetailsV2,
  studentsListOnly,
} from "../../api/Student";
import Master from "./Master";
import StudentEMI from "../student_v2/StudentEMI";
import useAppConfig from "../config/useAppConfig";

export default function StudentEnrollBatch() {
  const navigate = useNavigate();
  const config = useAppConfig("RTE", "rte_workflow");
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);
  const [data, setData] = useState({});
  const [courseData, setCourseData] = useState({});
  const [studentInfo, setStudentInfo] = useState({});

  const location = useLocation();
  const queryParam = new URLSearchParams(location.search);
  const student_id = queryParam.get("student_id");
  const batch_id = queryParam.get("batch_id");
  const [selectedFees, setSelectedFees] = useState({});

  const getStudentDetails = async (id) => {
    try {
      const response = await studentDetailsV2(`id=${id}`);

      if (response?.data?.status) {
        setStudentInfo(response?.data?.data || {});
      }
    } catch (error) {
      console.log(error);
    }
  };

  const selectedStudentId = data?.student_id || student_id;

  useEffect(() => {
    if (selectedStudentId) {
      getStudentDetails(selectedStudentId);
    }
  }, [selectedStudentId]);

  const getBatchList = async () => {
    setLoading(true);
    try {
      let addUrl = ``;
      if (data?.session_id) {
        addUrl += `session_id=${data?.session_id}`;
      }
      const response = await batchList(addUrl);
      if (response.data.status) {
        setBatches(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStudentList = async () => {
    setLoading(true);
    try {
      let addUrl = ``;
      if (data?.session_id) {
        addUrl += `session_id=${data?.session_id}`;
      }
      const response = await studentsListOnly(addUrl);
      if (response.data.status) {
        setStudents(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1);
    if (!activeSession) return;
    setData((prev) => ({
      ...prev,
      session_id: activeSession.id,
    }));
  }, [sessions]);

  useEffect(() => {
    getBatchList();
  }, [data?.session_id]);

  useEffect(() => {
    if (data?.session_id) {
      getStudentList();
    }
  }, [data?.session_id]);

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await studentBatchEnroll(formData);
      if (response?.data?.status) {
        if (studentInfo?.bus_status === "Yes") {
          navigate(`/student/bus/enroll?student_id=${selectedStudentId}`);
        } else {
          navigate(`/student/details?id=${selectedStudentId}`);
        }
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!batch_id) return;
    setData((prev) => ({
      ...prev,
      batch_id,
    }));
  }, [batch_id]);

  useEffect(() => {
    if (!data?.batch_id) return;

    const selectedBatch = batches?.find(
      (b) => Number(b.id) === Number(data.batch_id),
    );

    if (!selectedBatch) return;

    const excludeFees = ["Hostel Fee", "Library Fee", "Transport Fee"];

    let fees = (selectedBatch?.fee_details || [])
      .filter((fee) => !excludeFees.includes(fee.fee_type))
      .map((fee) => ({
        ...fee,
        amount: Number(fee.amount || 0),
        final_amount: Number(fee.amount || 0),
      }));

    if (studentInfo?.course_and_fee_info) {
      fees = fees.map((fee) =>
        fee.fee_type === "Registration Fee" && fee.apply_on === "New Student"
          ? {
            ...fee,
            amount: 0,
            final_amount: 0,
          }
          : fee,
      );
    }

    let rteConfig = [];

    try {
      rteConfig = JSON.parse(config?.value || "[]");
    } catch (e) { }

    if (data?.student_type === "RTE") {
      fees = fees.map((fee) => {
        const key = fee.fee_type
          ?.toLowerCase()
          ?.trim()
          ?.replace(/[^a-z0-9]+/g, "_")
          ?.replace(/^_|_$/g, "");

        const isFree = rteConfig?.find(
          (x) => x.key === key && Number(x.value) === 1,
        );

        return isFree
          ? {
            ...fee,
            amount: 0,
            final_amount: 0,
          }
          : fee;
      });
    }

    const total = fees.reduce((sum, fee) => sum + Number(fee.amount || 0), 0);
    const final_amount = fees.reduce(
      (sum, fee) => sum + Number(fee.final_amount || 0),
      0,
    );

    setCourseData({
      ...selectedBatch,
      fee_details: fees,
      total_fee: total,
      final_fee: final_amount,
    });
  }, [data?.batch_id, data?.student_type, studentInfo, config, batches]);

  useEffect(() => {
    if (courseData?.fee_details?.length) {
      const obj = {};

      courseData.fee_details.forEach((_, index) => {
        obj[index] = true;
      });

      setSelectedFees(obj);
    }
  }, [courseData?.fee_details]);

  const calculateTotalFee = (fees, checkedFees) => {
    return fees.reduce((sum, fee, index) => {
      return checkedFees[index] ? sum + Number(fee.amount || 0) : sum;
    }, 0);
  };
  const calculateFinalFee = (fees, checkedFees) => {
    return fees.reduce((sum, fee, index) => {
      return checkedFees[index] ? sum + Number(fee.final_amount || 0) : sum;
    }, 0);
  };

  const getFeesSummary = (fees, checkedFees) => {
    return fees.reduce(
      (acc, fee, index) => {
        if (checkedFees[index]) {
          acc.total += Number(fee.amount || 0);
          acc.final += Number(fee.final_amount || 0);
        }

        return acc;
      },
      {
        total: 0,
        final: 0,
      },
    );
  };
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <form onSubmit={handleAdd} method="post">
                          <div className="d-flex justify-content-between align-items-center">
                            <h4 className="text-primary mb-0">
                              Student Batch Enroll
                            </h4>

                            <div className="">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="student_id"
                                  value={data?.student_id || student_id || ""}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      student_id: e.target.value,
                                    })
                                  }
                                >
                                  <option value="" disabled selected>
                                    Select Student
                                  </option>
                                  {students?.map((student) => (
                                    <option
                                      key={student?.id}
                                      value={student?.id}
                                    >
                                      {student?.name} (
                                      {student?.registration_no}) -{" "}
                                      {student?.phone}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Student</label>
                              </div>
                            </div>
                          </div>

                          <hr />
                          <div className="row g-4">
                            <div className="col-sm-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="session_id"
                                  value={data?.session_id}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      session_id: e.target.value,
                                    })
                                  }
                                >
                                  {sessions?.map((session) => (
                                    <option
                                      key={session?.id}
                                      value={session?.id}
                                    >
                                      {session?.session}:
                                      {Number(session?.status) === 1
                                        ? "Active"
                                        : " Inactive"}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Session</label>
                              </div>
                            </div>

                            <div className="col-sm-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="batch_id"
                                  value={data?.batch_id}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      batch_id: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">
                                    Select Batch & Course
                                  </option>
                                  {batches?.map((batch) => (
                                    <option key={batch?.id} value={batch?.id}>
                                      {batch?.title} ({batch?.course?.title})
                                    </option>
                                  ))}
                                </select>
                                <label>Select Batch & Course</label>
                              </div>
                            </div>

                            <div className="col-sm-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="student_type"
                                  value={data?.student_type || "NONRTE"}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      student_type: e.target.value,
                                    })
                                  }
                                >
                                  <option value="NONRTE">
                                    NON-RTE Student
                                  </option>
                                  <option value="RTE">RTE Student</option>
                                </select>

                                <label>Select Student Type</label>
                              </div>
                            </div>

                            {courseData?.id && (
                              <>
                                <div className="col-12">
                                  <h6 className="text-primary mt-0 mb-2">
                                    Subject Details
                                  </h6>
                                  <div className="row g-3">
                                    {courseData?.course?.subjects_data?.map(
                                      (subject, i) => (
                                        <div
                                          className="col-auto me-4 text-nowrap"
                                          key={i}
                                        >
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              name="subjects[]"
                                              value={JSON.stringify(subject)}
                                              id={`subject_${subject?.id}`}
                                              defaultChecked={true}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={subject?.id}
                                            >
                                              {subject?.name} (
                                              {subject?.subject_code})
                                            </label>
                                          </div>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                </div>

                                <div className="col-12">
                                  <h6 className="text-primary mt-0 mb-2">
                                    Fee Details
                                  </h6>

                                  <div className="row g-3 align-items-end">
                                    <input
                                      type="hidden"
                                      name="course_id"
                                      value={courseData?.course_id}
                                    />
                                    {courseData?.fee_details?.map(
                                      (fee, index) => (
                                        <div className="col-auto" key={index}>
                                          <div className="form-check">
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              name={`fee_apply[${index}]`}
                                              value="1"
                                              id={`fee_${index}`}
                                              checked={
                                                fee?.fee_type ===
                                                  "Registration Fee"
                                                  ? true
                                                  : selectedFees[index] || false
                                              }
                                              onChange={(e) => {
                                                let updated = {};
                                                if (
                                                  fee?.fee_type ===
                                                  "Registration Fee"
                                                ) {
                                                  updated = {
                                                    ...selectedFees,
                                                    [index]: true,
                                                  };
                                                } else {
                                                  updated = {
                                                    ...selectedFees,
                                                    [index]: e.target.checked,
                                                  };
                                                }

                                                setSelectedFees(updated);

                                                const summary = getFeesSummary(
                                                  courseData.fee_details,
                                                  updated,
                                                );

                                                setCourseData((prev) => ({
                                                  ...prev,
                                                  total_fee: summary.total,
                                                  final_fee: summary.final,
                                                }));
                                              }}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`fee_${index}`}
                                            >
                                              {fee.fee_type} (₹{fee.amount})
                                            </label>
                                          </div>

                                          {selectedFees[index] && (
                                            <>
                                              <input
                                                type="hidden"
                                                name={`fee_type[${index}]`}
                                                value={fee.fee_type}
                                              />
                                              <input
                                                type="hidden"
                                                name={`total[${index}]`}
                                                value={fee.amount}
                                              />

                                              <div className="form-floating form-floating-outline">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  name={`final[${index}]`}
                                                  value={fee.final_amount}
                                                  min="0"
                                                  onChange={(e) => {
                                                    let value = 0;
                                                    if (
                                                      fee?.fee_type ===
                                                      "Registration Fee"
                                                    ) {
                                                      value = Number(
                                                        fee?.amount,
                                                      );
                                                    } else {
                                                      value = Number(
                                                        e.target.value || 0,
                                                      );
                                                    }

                                                    const updatedFees = [
                                                      ...courseData.fee_details,
                                                    ];

                                                    updatedFees[index] = {
                                                      ...updatedFees[index],
                                                      final_amount: value,
                                                    };

                                                    const total =
                                                      updatedFees.reduce(
                                                        (sum, item, i) => {
                                                          return selectedFees[i]
                                                            ? sum +
                                                            Number(
                                                              item.amount ||
                                                              0,
                                                            )
                                                            : sum;
                                                        },
                                                        0,
                                                      );

                                                    const final_amount =
                                                      updatedFees.reduce(
                                                        (sum, item, i) => {
                                                          return selectedFees[i]
                                                            ? sum +
                                                            Number(
                                                              item.final_amount ||
                                                              0,
                                                            )
                                                            : sum;
                                                        },
                                                        0,
                                                      );

                                                    setCourseData((prev) => ({
                                                      ...prev,
                                                      fee_details: updatedFees,
                                                      total_fee: total,
                                                      final_fee: final_amount,
                                                    }));
                                                  }}
                                                />
                                                <label>Amount</label>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      ),
                                    )}
                                    <div className="col-auto">
                                      <div className="form-floating form-floating-outline">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="total_fee"
                                          placeholder="Total Fee"
                                          value={courseData?.total_fee}
                                          readOnly
                                        />
                                        <label>Total Fee</label>
                                      </div>
                                    </div>
                                    <div className="col-auto">
                                      <div className="form-floating form-floating-outline">
                                        <input
                                          type="number"
                                          name="final_fee"
                                          className="form-control"
                                          readOnly
                                          value={courseData?.final_fee}
                                          onChange={(e) => {
                                            let value = Number(
                                              e.target.value || 0,
                                            );

                                            if (
                                              value >
                                              Number(courseData.total_fee)
                                            ) {
                                              value = Number(
                                                courseData.total_fee,
                                              );
                                            }

                                            setCourseData((prev) => ({
                                              ...prev,
                                              final_fee: value,
                                            }));
                                          }}
                                        />
                                        <label>Final Fee</label>
                                      </div>
                                    </div>
                                    {courseData?.total_fee -
                                      courseData?.final_fee >
                                      0 && (
                                        <div className="col-auto">
                                          <div className="form-floating form-floating-outline">
                                            <input
                                              type="text"
                                              className="form-control input-uppercase"
                                              name="discount_remark"
                                              placeholder="Discount Remark"
                                              required
                                            />
                                            <label>Discount Remark</label>
                                          </div>
                                        </div>
                                      )}

                                    {Number(courseData?.final_fee) > 0 && (
                                      <StudentEMI
                                        finalFee={courseData?.final_fee}
                                      />
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="col-12 text-end">
                              <button
                                type="submit"
                                disabled={loading}
                                className="btn btn-sm btn-primary px-12"
                              >
                                {loading ? "Saving..." : "Save"}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
